import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import CreatePresentationImg from './create-presentation.png';
import AddToPlaylistImg from './add-to-playlist.png';
import PublishToDeviceImg from './publish-to-device.png';
import { useUpdateOnboardingStatus } from '../../../../../hooks';
import { useTranslation } from 'react-i18next';

export interface LibraryOnboardingDialogProps {
  isOpen: boolean;
}

const LibraryOnboardingDialog = ({ isOpen }: LibraryOnboardingDialogProps) => {
  const updateOnboardingStatus = useUpdateOnboardingStatus();
  const { t } = useTranslation();

  const handleUpdateOnboardingStatus = async () => {
    try {
      await updateOnboardingStatus.mutate({ name: 'library' });
    } catch (error) {
      console.error(error);
    }
  };

  const renderGetStartedContent = () => {
    return (
      <div className="text-black">
        <DialogHeader>
          <DialogHeading>Start creating content</DialogHeading>
        </DialogHeader>
        <div className="flex flex-col pt-4 gap-8 md:px-8 ">
          <div className="flex items-center">
            <img
              src={CreatePresentationImg}
              alt="create a presentation"
              className="w-[129.65px] h-auto"
            />
            <div className="flex flex-col flex-1 ml-6">
              <Text variant="smallSubheader">1. Create a presentation</Text>
              <Text className="text-gray-600" variant="body">
                Use {t('companyName')} apps or upload images, videos or PDF’s
              </Text>
            </div>
          </div>
          <div className="flex items-center">
            <img
              src={AddToPlaylistImg}
              alt="add it to a playlist"
              className="w-[129.65px] h-auto"
            />
            <div className="flex flex-col flex-1 ml-6">
              <Text variant="smallSubheader">2. Add it to a playlist</Text>
              <Text className="text-gray-600" variant="body">
                Combine content into playlists
              </Text>
            </div>
          </div>
          <div className="flex items-center">
            <img
              src={PublishToDeviceImg}
              alt="publish to device"
              className="w-[129.65px] h-auto"
            />
            <div className="flex flex-col flex-1 ml-6">
              <Text variant="smallSubheader">3. Publish to device</Text>
              <Text className="text-gray-600" variant="body">
                Publish your playlists to a screen
              </Text>
            </div>
          </div>
        </div>
        <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
          <Button
            size="large"
            variant="primary"
            className="grow"
            onPress={() => handleUpdateOnboardingStatus()}
          >
            Let's Go!
          </Button>
        </footer>
      </div>
    );
  };

  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid gap-4 relative">
        {renderGetStartedContent()}
      </Dialog>
    </Modal>
  );
};

export default LibraryOnboardingDialog;
